import { fadeInLeft, fadeInRight, fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../../../assets/styles/colors";

const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
const fadeInRightAnimation = keyframes`${fadeInRight}`;
const fadeInAnimation = keyframes`${fadeIn}`;

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const CardLink = styled.a``;

export const Container = styled.div`
  animation: 2s ${fadeInAnimation};
`;

export const PaymethodTitle = styled.div`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackFive
      : Color.textColorBlackOne};
`;

export const PaymethodIcon = styled.i`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackFive
      : Color.textColorBlackOne};
`;

export const ContainerPaymethod = styled.div`
  animation: 1s
    ${(props) => (props.sel ? fadeInLeftAnimation : fadeInRightAnimation)};
`;
